import { Box, Span } from '@bpba/ui-components';

type SlideInfoProps = {
  titulo: string;
  subtitulo: string;
};

export const SlideInfo = (props: SlideInfoProps) => {
  if (props === null || (!props.titulo && !props.subtitulo)) return <></>;

  return (
    <Box
      backgroundImage={'linear-gradient(rgba(0,0,0,0.50), rgba(0,0,0,0.50))'}
      position={'absolute'}
      bottom={'0px'}
      backgroundSize={'cover'}
      backgroundColor={'transparent'}
      height="fit-content"
      borderRadius={['0px 0px 8px 32px']}
      flexDirection="column"
      padding={5}
      color={'white'}
    >
      <Span fontSize={'20px'} fontWeight={'500'}>
        {props.titulo}
      </Span>
      <Span marginTop={'5px'}>{props.subtitulo}</Span>
    </Box>
  );
};
